import ConfirmationDialog from '@/components/UI/ConfirmationDialog';
import type { StrategySubscriptionRow } from './strategySubscription';

interface LiveStrategyDeactivationDialogProps {
    /** The subscription waiting for confirmation; the dialog is closed while this is null. */
    row: StrategySubscriptionRow | null;
    onConfirm: () => void;
    onCancel: () => void;
}

/** Confirms switching off a strategy in a live portfolio, which stops real-money entries immediately. */
const LiveStrategyDeactivationDialog = ({ row, onConfirm, onCancel }: LiveStrategyDeactivationDialogProps) => (
    <ConfirmationDialog
        confirmText="Turn off"
        confirmVariant="danger"
        isOpen={row !== null}
        message={
            <>
                <p>
                    Turn off <span className="font-medium text-white">{row?.strategy.name}</span> in the live portfolio{' '}
                    <span className="font-medium text-white">{row?.portfolio.name}</span>? It stops opening new real-money positions
                    immediately.
                </p>
                <p className="mt-2 text-sm text-zinc-400">
                    Existing open positions are not closed. The change is recorded with your account and device.
                </p>
            </>
        }
        title="Turn off live strategy"
        onCancel={onCancel}
        onConfirm={onConfirm}
    />
);

export default LiveStrategyDeactivationDialog;
